module.exports = __webpack_public_path__ + "static/img/Jesse-Ramien.c029aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-Ramien.jpg
// module id = Ro+D
// module chunks = 0